<template>
  <div>
    <div style="font-size: 16px;line-height: 28px;">
      <P>为使参展企业达到最佳的宣传效果，主办方推出了展前、展中、展后全周期的线上线下、多种类、全方位的整合营销方案，是企业展示新产品、新技术，宣传、树立企业形象，从供应商中脱颖而出的最佳途径。宣传机会有限，火热征集中。</P>
      <p>发放范围：线下展会和线上同步宣传，覆盖150,000 行业人士。</p>
      <p>更多详情请参见<a :href="demoExcel" style="font-size:16px;text-decoration:none;"  target="_blank">《CAC 整合营销方案》</a></p>
      <p>刘凌玥 电话：010-64221778 邮箱：<a href="mailto:liuly@ccpitchem.org.cn">liuly@ccpitchem.org.cn</a></p>
      <el-button type="primary" :style="buttonStyle" ><a :href="demoExcel" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank">CAC整合营销手册</a></el-button>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  data: () => ({
     saveBtnStatue:false,  //保存铵钮状态
      demoExcel:'./CAC2025整合营销手册.pdf'
  }),

  components: {},
  mounted() {

  },
  methods: {
    downfile(){

    },


  }
}
</script>
<style lang="less">


</style>

